export default "__VITE_ASSET__C4PGyjG6__"